import React from "react";
import { Badge, Button, Form, Table } from "react-bootstrap";

const queryData = [
  {
    id: "Q-100010",
    site: "04",
    subject: "04-011",
    visit: "Week 2",
    form: "ECG",
    field: "QTcF Interval",
    queryText:
      "Response for QTcF Interval conflicts with eligibility criteria. Please verify against source.",
    category: "Eligibility issue",
    priority: "Critical",
    status: "Open",
    aging: "0 d",
    sla: "In SLA",
    createdBy: "R. Sharma",
    created: "10 Jun 2026",
    assignedTo: "E. Weber",
    closed: "—",
    reopen: 0,
    source: "Manual",
    sdv: "Pending",
  },
  {
    id: "Q-100181",
    site: "06",
    subject: "06-010",
    visit: "Week 8",
    form: "Laboratory",
    field: "Platelets",
    queryText:
      "Entry for Platelets suggests a possible protocol deviation. Please confirm.",
    category: "Protocol deviation related",
    priority: "High",
    status: "Open",
    aging: "0 d",
    sla: "In SLA",
    createdBy: "S. Kulkarni",
    created: "10 Jun 2026",
    assignedTo: "B. Miller",
    closed: "—",
    reopen: 0,
    source: "Manual",
    sdv: "Verified",
  },
  {
    id: "Q-100316",
    site: "05",
    subject: "05-008",
    visit: "End of Study",
    form: "Laboratory",
    field: "Hemoglobin",
    queryText:
      "Hemoglobin occurs before the previous assessment date. Please verify the date.",
    category: "Date inconsistency",
    priority: "High",
    status: "Open",
    aging: "0 d",
    sla: "In SLA",
    createdBy: "System (Edit Check)",
    created: "10 Jun 2026",
    assignedTo: "K. Zielinski",
    closed: "—",
    reopen: 0,
    source: "EC-250",
    sdv: "Partially verified",
  },
];

const getPriorityVariant = (priority) => {
  switch (priority) {
    case "Critical":
      return "danger";
    case "High":
      return "warning";
    case "Medium":
      return "info";
    case "Low":
      return "secondary";
    default:
      return "light";
  }
};

const getSDVVariant = (status) => {
  switch (status) {
    case "Verified":
      return "success";
    case "Pending":
      return "warning";
    default:
      return "secondary";
  }
};

const QueryListingTable = () => {
  return (
    <div className="table-responsive">
      <Table className="m-0 custom-table" hover striped>
        <thead className="position-sticky top-0 z-1">
          <tr>
            <th style={{ width: 45 }} className="text-center">
              <Form.Check />
            </th>
            <th>Query ID</th>
            <th>Site</th>
            <th>Subject</th>
            <th>Visit</th>
            <th>Form</th>
            <th>Field</th>
            <th style={{ minWidth: 320 }}>Query Text</th>
            <th>Category</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Aging</th>
            <th>SLA</th>
            <th>Created By</th>
            <th>Created</th>
            <th>Assigned To</th>
            <th>Closed</th>
            <th>Re-open</th>
            <th>Source</th>
            <th>SDV</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {queryData.map((row) => (
            <tr key={row.id}>
              <td className="text-center">
                <Form.Check />
              </td>

              <td className="fw-bold text-primary">{row.id}</td>

              <td>{row.site}</td>
              <td>{row.subject}</td>
              <td>{row.visit}</td>
              <td>{row.form}</td>
              <td>{row.field}</td>

              <td>{row.queryText}</td>

              <td>{row.category}</td>

              <td>
                <Badge bg={getPriorityVariant(row.priority)}>
                  {row.priority}
                </Badge>
              </td>

              <td>
                <Badge bg="primary">{row.status}</Badge>
              </td>

              <td>{row.aging}</td>

              <td>
                <Badge bg="success">{row.sla}</Badge>
              </td>

              <td>{row.createdBy}</td>
              <td>{row.created}</td>
              <td>{row.assignedTo}</td>
              <td>{row.closed}</td>
              <td>{row.reopen}</td>
              <td>{row.source}</td>

              <td>
                <Badge bg={getSDVVariant(row.sdv)}>{row.sdv}</Badge>
              </td>

              <td>
                <button className="updateProfile p-0 px-2">View</button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default QueryListingTable;
